import { defineStore } from 'pinia';

export const useAlertStore = defineStore('alert', {
  state: () => ({
    isAlert: false,
    type: 'success',
    message: '',
  }),
  actions: {
    reset() {
      this.isAlert = false;
      this.type = 'success';
      this.message = '';
    },
    createAlert(type, message) {
      this.isAlert = true;
      this.type = type;
      this.message = message;
    },
  },
});
